<template>
<div id="instPreWin">
  <img src="@/assets/vector/winnersvg.svg" alt="" svg-inline>
  <div v-if="calcVirginDraft">
    <h4>Поздравляем! Ваша заявка предварительно одобрена</h4>
    <p>Подтвердите личность и получите деньги!</p>
  </div>
  <div v-else>
    <h4>Внесите изменения в документы.</h4>
    <p>{{demandState.comment}}</p>
  </div>
</div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instPreWin",
  computed: {
    ...mapState({
      demandState: state => state.instForm.demandState,
    }),
    calcVirginDraft(){
      return (this.demandState.allPhotosStatusList.passport1 +
              this.demandState.allPhotosStatusList.passport2 +
              this.demandState.allPhotosStatusList.passport3 +
              this.demandState.allPhotosStatusList.selfImage +
              this.demandState.allPhotosStatusList.BankAccount) === 0;
    }
  }
}
</script>

<style scoped>
#instPreWin{border-radius: var(--font-size-04);background: var(--color-green-light);
padding:var(--font-size-16) var(--font-size-08);display: flex;align-items: flex-start;justify-content: flex-start;
  color:var(--color-dark-green);margin: var(--font-size-16) 0}
#instPreWin img{width: var(--font-size-21);height: var(--font-size-21);margin-right: var(--font-size-16)}
h4{font-weight: 500;font-size: var(--font-size-16);margin: 0}
p{margin: var(--font-size-08) 0;font-size: var(--font-size-16)}
</style>